import { CartItem } from "./useReturnState.types";

export const calculateCartItemsCost = (cartItems: CartItem[]) => {
  return cartItems.reduce((total, item) => {
    return total + item.price * item.selectedQuantity;
  }, 0);
};
